export const experienceData = [
    
    {
        id: 1,
        company: 'Ajatus Software ',
        jobtitle: 'Frontend developer',
        startYear: '2021-jan',
        endYear: '2021-may'
    },
    {
        id: 2,
        company: 'Louoj technology Pvt Ltd',
        jobtitle: 'Frontend Developer',
        startYear: '2021-jun',
        endYear: '2021-september'
    },
    {
        id: 3,
        company: 'Apie technologies',
        jobtitle: 'Frontend Developer',
        startYear: '2021-october',
        endYear: 'present'
    }

]